var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExcel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1861 9.5L4.88379 8V19.0835C4.88379 19.5897 5.28458 20 5.77897 20H20.1049C20.5993 20 21.0001 19.5897 21.0001 19.0835V15L13.1861 9.5Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1861 0H5.77897C5.28458 0 4.88379 0.410329 4.88379 0.916498V5L13.1861 10L17.5815 11.5L21.0001 10V5L13.1861 0Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88379 5H13.1861V10H4.88379V5Z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.8258 4H4.88379V16.5H10.8258C11.3195 16.4984 11.7194 16.089 11.721 15.5835V4.9165C11.7194 4.41101 11.3195 4.00164 10.8258 4Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.3374 4.5H4.88379V17H10.3374C10.8312 16.9984 11.231 16.589 11.2326 16.0835V5.4165C11.231 4.91101 10.8312 4.50164 10.3374 4.5Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.3374 4.5H4.88379V16H10.3374C10.8312 15.9984 11.231 15.589 11.2326 15.0835V5.4165C11.231 4.91101 10.8312 4.50164 10.3374 4.5Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.84907 4.5H4.88379V16H9.84907C10.3428 15.9984 10.7426 15.589 10.7443 15.0835V5.4165C10.7426 4.91101 10.3428 4.50164 9.84907 4.5Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.895184 4.5H9.84899C10.3434 4.5 10.7442 4.91033 10.7442 5.4165V14.5835C10.7442 15.0897 10.3434 15.5 9.84899 15.5H0.895184C0.400786 15.5 0 15.0897 0 14.5835V5.4165C0 4.91033 0.400786 4.5 0.895184 4.5Z",
    fill: "url(#paint0_linear_129_2990)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77246 12.979L4.65562 9.99151L2.93021 7.02051H4.31816L5.25974 8.92051C5.34667 9.10101 5.40625 9.23501 5.43849 9.3235H5.45069C5.51255 9.1795 5.57767 9.03967 5.64604 8.904L6.65258 7.02151H7.92674L6.15736 9.97502L7.97168 12.979H6.61595L5.52835 10.8935C5.47712 10.8048 5.43364 10.7116 5.39844 10.615H5.38233C5.35047 10.7096 5.3082 10.8002 5.25633 10.885L4.13649 12.979H2.77246Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1048 0H13.186V5H21V0.916498C21 0.410329 20.5992 0 20.1048 0Z",
    fill: "#33C481"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.186 10H21V15H13.186V10Z",
    fill: "#107C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_129_2990",
    x1: 1.86648,
    y1: 3.78387,
    x2: 9.12806,
    y2: 16.0681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/Excel.4c052c94b44cd5143f7208d8379319f8.svg";
export { ForwardRef as ReactComponent };